<div class="modifier-group-container">
  <div class="button-group">
    <button mat-raised-button color="primary" (click)="onApplyModifierGroup()">{{ 'COMMON.APPLY' | translate }}</button>
    <button mat-raised-button color="accent" (click)="onClickCreateModifierGroup()">{{ 'COMMON.CREATE' | translate }}</button>
    <span *ngIf="loading" class="loading-indicator">
      {{ 'COMMON.LOADING' | translate }}
    </span>
  </div>
  <div *ngIf="hasProductsMissingFromMenu" class="stale-products-warning">
    {{ 'MENU.MODIFIER_GROUP.STALE_PRODUCTS_WARNING' | translate }}
  </div>
  <div class="modifier-list">
    <app-modifier-group-item
      *ngFor="let mg of modifierGroups"
      [modifierGroup]="mg"
      [organization]="organization"
      [modifiers]="modifiers"
      (changedChecked)="selectModifierGroupHandler($event)"
      (loading)="onLoadingHandler($event)"
      (deleting)="onDeleteHandler($event)"
      class="modifier-item"
    ></app-modifier-group-item>
  </div>
</div>

